import { FormControlOptions } from '@miq/catalog';

export const AvailabilityFormConfig: { [key: string]: FormControlOptions<any> } = Object.freeze({
  colloquial: {
    name: 'colloquial',
    type: 'array',
    controlsConfig: {
      id: [null],
      _mode: [null],
      country_code_desc: [null],
      language_desc: [null],
    },
  },
  // Associated Alternate address for insert mode
  alternate_address_id: {
    name: 'alternate_address_id',
    type: 'control',
  },
  // Associated Alternate address
  alternate_address: {
    name: 'alternate_address',
    type: 'group',
    controlsConfig: {
      id: [null],
      full_street_name: [null],
      latitude: [null],
      longitude: [null],
      major_corridor_type_desc: [null],
      action: [null],
    },
  },
  property: {
    name: 'property',
    type: 'group',
    controlsConfig: {
      ref_property_tenancy_type_desc: [null],
    },
    children: {
      colloquial: {
        name: 'colloquial',
        type: 'array',
        controlsConfig: {
          id: [null],
          _mode: [null],
          country_code_desc: [null],
          language_desc: [null],
        },
      },
      postal_address: {
        name: 'postal_address',
        type: 'group',
        controlsConfig: {
          country: [null],
          longitude: [null],
          latitude: [null],
        },
        children: {
          colloquial: {
            name: 'colloquial',
            type: 'array',
            controlsConfig: {
              country_code_desc: [null],
              language_desc: [null],
              id: [null],
              _mode: [null],
            },
          },
        },
      },
      property_usage: {
        name: 'property_usage',
        type: 'group',
        controlsConfig: {
          id: [null],
          ref_property_usage_type_desc: [null],
          net_rentable_area: [null],
        },
        children: {
          usage_amenity: {
            name: 'usage_amenity',
            type: 'array',
            controlsConfig: {
              id: [null],
              _mode: [null],
            },
          },
          property_external_ratings: {
            name: 'property_external_ratings',
            type: 'array',
            controlsConfig: { id: [null], _mode: [null] },
          },
        },
      },
    },
  },
  availability_notes: {
    type: 'array',
    name: 'availability_notes',
    controlsConfig: {
      id: [''],
    },
  },
  property_measurement_availability: {
    name: 'property_measurement_availability',
    type: 'array',
    controlsConfig: {
      id: [null],
      _mode: [null],
    },
  },
  availability_frontage: {
    name: 'availability_frontage',
    type: 'array',
    controlsConfig: {
      id: [null],
      _mode: [null],
    },
  },
  availability_status_history: {
    name: 'availability_status_history',
    type: 'array',
    controlsConfig: {
      id: [null],
      _mode: [null],
    },
  },
  company_contact_role_addresses: {
    name: 'company_contact_role_addresses',
    type: 'array',
    controlsConfig: {
      id: [''],
      _mode: [null],
      _contact_id: [null], // ensure presence
      display_order: [null], // ensure presence
      prev_display_order: [null], // ensure presence
      company_id: [null], // ensure presence
      contact_id: [null], // ensure presence
      role_desc: [null], // ensure presence
      location_id: [null], // ensure presence - flat mirror of location.location_id (MIQ-36890)
      familiar_name: [null],
      children: [],
      location: [],
      first_name: [null],
      last_name: [null],
      email: [null],
      full_phone_number: [null],
      company_legal_name: [null],
      primary_f: [null],
    },
    children: {
      company_industry_classification: {
        name: 'company_industry_classification',
        type: 'array',
        controlsConfig: {
          id: [null],
          ref_naics_classification_desc: [null],
          primary_naics_code_f: [null],
        },
      },
      colloquial: {
        name: 'colloquial',
        type: 'array',
        controlsConfig: {
          id: [null],
          _mode: [null],
          country_code_desc: [null],
          language_desc: [null],
        },
      },
    },
  },
  // Yield
  yield: {
    type: 'array',
    name: 'yield',
    controlsConfig: {
      id: [null],
      _mode: [null],
    },
  },
  // Income
  income: {
    type: 'array',
    name: 'income',
    controlsConfig: {
      id: [null],
      _mode: [null],
    },
  },
  listing_ids: {
    type: 'array',
    name: 'listing_ids',
    controlsConfig: {
      id: [null],
      _mode: [null],
    },
  },
  workspace: {
    type: 'group',
    name: 'workspace',
    children: {
      operating_hours: {
        type: 'array',
        name: 'operating_hours',
        controlsConfig: {
          id: [null],
        },
      },
      locks: {
        type: 'array',
        name: 'locks',
        controlsConfig: {
          id: [null],
        },
      },
    },
  },
});
